import React from "react";
import VopHeader from "components/vop_header";

import VopIndexBanner from "components/vop_index_banner";
import VopIndexBannerData from "./data/vop_index_banner/data";

import VopIndexTip from "components/vop_index_tip";
import VopIndexTipData from "./data/vop_index_tip/data";

import VopIndexProdService from "components/vop_index_prod_service";
import VopIndexProdServiceData from "./data/vop_index_prod_service/data";

import VopIndexSenceSolve from "components/vop_index_sence_solve";
import VopIndexSenceSolveData from "./data/vop_index_sence_solve/data";

import VopIndexSolveCase from "components/vop_index_solve_case";
import VopIndexSolveCaseData from "./data/vop_index_solve_case/data";

import VopAdvantage from "components/vop_advantage";
import VopAdvantageData from "./data/vop_advantage/data";

import VopCooperation from "components/vop_cooperation";
import VopCooperationData from "./data/vop_cooperation/data";

import VopFooter from "components/vop_footer";

import HomeHeader from "components/HomeHeader"

import FeedBack from "components/vop_feedback";

import SurveyInfo from "components/vop_surveyInfo";

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        bgColor: 'transparent',
        headerData: { bgColor: "linear-gradient(180deg, rgba(7,7,7,1) 0%,rgba(3,3,3,0) 100%)"}
    }
  }
  componentDidMount() {
    document.title = '京东VOP开放平台-门户';

    window.scrollTo(0, 0);

    window.onscroll = () => {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if(scrollTop > 50) {
        this.setState({
            headerData: Object.assign(this.state.headerData, {bgColor: "#000"})
        })
      } else {
        this.setState({
            headerData: Object.assign(this.state.headerData, {bgColor: "linear-gradient(180deg, rgba(7,7,7,1) 0%,rgba(3,3,3,0) 100%)"})
        })
      }
    }

    
  }

  
  render() {
    return (
      <React.Fragment>
        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div
                className="jdw-widget"
                data-name="vop_header"
                data-version="7.0.0"
              >
                <VopHeader {...this.state.headerData} contentWidth="1200px">
                    <HomeHeader textStyle={{color: "#fff",fontWeight: "bold"}}/>
                </VopHeader>
              </div>
            </div>
          </div>
        </div>

        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div
                className="jdw-widget"
                data-name="vop_index_banner"
                data-version="7.0.0"
              >
                <VopIndexBanner {...VopIndexBannerData} />
              </div>
            </div>
          </div>
        </div>

        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div
                className="jdw-widget"
                data-name="vop_index_tip"
                data-version="5.0.0"
              >
                <VopIndexTip {...VopIndexTipData} />
              </div>
            </div>
          </div>
        </div>

        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div
                className="jdw-widget"
                data-name="vop_index_prod_service"
                data-version="3.0.0"
              >
                <VopIndexProdService {...VopIndexProdServiceData} />
              </div>
            </div>
          </div>
        </div>

        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div
                className="jdw-widget"
                data-name="vop_index_sence_solve"
                data-version="2.0.0"
              >
                <VopIndexSenceSolve {...VopIndexSenceSolveData} />
              </div>
            </div>
          </div>
        </div>

        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div
                className="jdw-widget"
                data-name="vop_index_solve_case"
                data-version="3.0.0"
              >
                <VopIndexSolveCase {...VopIndexSolveCaseData} />
              </div>
            </div>
          </div>
        </div>

        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div
                className="jdw-widget"
                data-name="vop_advantage"
                data-version="6.0.0"
              >
                <VopAdvantage {...VopAdvantageData} />
              </div>
            </div>
          </div>
        </div>

        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div
                className="jdw-widget"
                data-name="vop_cooperation"
                data-version="8.0.0"
              >
                <VopCooperation {...VopCooperationData} />
              </div>
            </div>
          </div>
        </div>

        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div
                className="jdw-widget"
                data-name="vop_footer"
                data-version="2.0.0"
              >
                <VopFooter />
              </div>
            </div>
          </div>
        </div>


        <FeedBack></FeedBack>
        <SurveyInfo></SurveyInfo>

      </React.Fragment>
    );
  }
}

export default Home;
